<template>
    <div class="mb-28px">
        <v-row no-gutters class="row-cols-md-5 my-n4px">
            <v-col class="my-4px">
                <v-btn x-large block :color="`${_category ? 'transparent' : 'primary'}`" @click="$router.push('/gshop/brand?page=1')">
                    <span class="mr-4px mr-md-6px">
                        <v-img :src="`${_category ? '/images/giftcard/all_b.png' : '/images/giftcard/all_w.png'}`" alt="all" :aspect-ratio="25 / 26" width="26" height="25" contain />
                    </span>
                    <span class="font-size-14 font-size-lg-18">
                        전체
                    </span>
                </v-btn>
            </v-col>
            <v-col v-for="category in categories" :key="category._id" class="my-4px">
                <v-btn x-large block :color="`${_category === category._id ? 'primary' : 'transparent'}`" @click="$router.push(`/gshop/brand?_category=${category?._id}&page=1`)">
                    <span class="mr-4px mr-lg-6px">
                        <v-img :src="`${_category === category._id ? `https://daehanbooksgiftcard.com/${category?.icon2}` : `https://daehanbooksgiftcard.com/${category?.icon}`}`" :aspect-ratio="25 / 26" width="26" height="25" contain />
                    </span>
                    <span class="font-size-14 font-size-lg-18">
                        {{ category?.name }}
                    </span> 
                </v-btn>
            </v-col>

            <!-- is-active가 붙을 시 활성화 효과 -->
            <!-- <v-col cols="4"  :class="`gift-item d-flex justify-center align-center border flex-column flex-md-row py-10px py-md-20px ${_category ? '' : 'is-active'}`" @click="$router.push('/gshop/brand?page=1')">
                <span class="pr-0 pr-md-6px">
                    <v-img class="black-icon" :aspect-ratio="25 / 26" width="26" height="25" contain src="/images/giftcard/all_b.png" alt="all" />
                    <v-img class="white-icon" :aspect-ratio="25 / 26" width="26" height="25" contain src="/images/giftcard/all_w.png" alt="all" />
                </span>
                <p class="font-size-14 font-size-md-18">전체</p>
            </v-col>
            <v-col cols="4" v-for="category in categories" :key="category._id" :class="`gift-item d-flex justify-center align-center border  flex-column flex-md-row py-10px py-md-20px ${_category === category._id ? 'is-active' : ''}`" @click="$router.push(`/gshop/brand?_category=${category?._id}&page=1`)">
                <span class="pr-0 pr-md-6px">
                    <v-img class="black-icon" :aspect-ratio="28 / 27" width="28" height="27" contain :src="`https://salerbookcash.com/${category?.icon}`" alt="all" />
                    <v-img class="white-icon" :aspect-ratio="28 / 27" width="28" height="27" contain :src="`https://salerbookcash.com/${category?.icon2}`" alt="all" />
                </span>
                <p class="font-size-14 font-size-md-18">{{ category?.name }}</p>
            </v-col> -->
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        categories: { type: Array, default: [] }
    },
    data() {
        return {};
    },
    methods: {
        move(category) {
            this.$router.push(`/gshop/brand?_category=${category?._id}`)
        }
    },
    computed: {
        _category() {
            return this.$route.query._category;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .v-btn.v-size--default{
    height: 56px;
}
::v-deep .v-btn.transparent{
    color: #595656 !important;
}

.row{
    >[class*="col"]{
        border: 1px solid var(--border-color);
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
    .row{
        >[class*="col"]{
            &:not(:nth-child(5n)){
                border-right: 0;
            }
        }
    }
}
@media (min-width:1024px){
    ::v-deep .v-btn.v-size--default{
        height: 80px;
    }
}
@media (min-width:1200px){
}


// .gift-item {
//     color: #595656;
//     cursor: pointer;
//     .black-icon {
//         display: block;
//     }
//     .white-icon {
//         display: none;
//     }

//     &:not(:last-child) {
//         border-right: none !important;
//     }

//     &.is-active {
//         color: #fff;
//         background-color: var(--v-primary-base) !important;

//         .black-icon {
//             display: none;
//         }
//         .white-icon {
//             display: block;
//         }
//     }

//     &.v-tab--active {
//         color: #fff;
//         background-color: var(--v-primary-base) !important;

//         .black-icon {
//             display: none;
//         }
//         .white-icon {
//             display: block;
//         }
//     }
// }
</style>
